import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import NotificationSystem from 'rc-notification';
import SmartCard from '../../../shared/components/SmartCard';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  showNotification,
  showNotificationAutoDestroy,
} from '../../../shared/components/ShowNotification';
import GraphQL from '../../../GraphQL';
import TeachingTechniqueForm from './Form';
import {
  teachingTechniqueListByFilter,
  teachingTechniqueSave,
} from '../../../shared/queries/TeachingTechnique';

let notificationInstance = null;

const TeachingTechniqueFormHandler = (props) => {
  const { t, dispatch, match, history } = props;

  const [formOn, setFormOn] = useState(false);
  const [dto, setDto] = useState({ id: 0, active: true });

  const notification = (color, title, message) =>
    showNotification(notificationInstance, color, title, message);

  useEffect(() => {
    NotificationSystem.newInstance({}, (n) => {
      notificationInstance = n;
      return notificationInstance;
    });
  }, []);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const backClickHandler = () => {
    history.push('/minime/tecnica-ensino');
  };

  const handleSubmit = (values) => {
    showLoading();
    const mutationQuery = teachingTechniqueSave(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  function findById(id) {
    showLoading();
    const filter = {
      updaterId: 0,
      active: true,
      id,
    };
    const query = teachingTechniqueListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.teachingTechniqueListByFilter) {
          setDto({
            ...res.teachingTechniqueListByFilter[0],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        if (error.response) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.tecnica-ensino')}>
      {formOn ? (
        <TeachingTechniqueForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          notification={notification}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

TeachingTechniqueFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.func.isRequired,
  match: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(TeachingTechniqueFormHandler)
);
